import { render, staticRenderFns } from "./TableMosaicTransactions.vue?vue&type=template&id=3c618646&scoped=true&"
import script from "./TableMosaicTransactions.vue?vue&type=script&lang=js&"
export * from "./TableMosaicTransactions.vue?vue&type=script&lang=js&"
import style0 from "./TableMosaicTransactions.vue?vue&type=style&index=0&id=3c618646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c618646",
  null
  
)

export default component.exports